import { render, staticRenderFns } from "./exp_pres_detalle.vue?vue&type=template&id=13c36732&scoped=true"
import script from "./exp_pres_detalle.vue?vue&type=script&lang=js"
export * from "./exp_pres_detalle.vue?vue&type=script&lang=js"
import style0 from "./exp_pres_detalle.vue?vue&type=style&index=0&id=13c36732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c36732",
  null
  
)

export default component.exports